import { render, staticRenderFns } from "./common-tips.component.vue?vue&type=template&id=4a0a0ead"
import script from "./common-tips.component.vue?vue&type=script&lang=js"
export * from "./common-tips.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports